<template>
  <v-dialog
    :value="show"
    lazy
    scrollable
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :width="$store.state.common.largeDialogWidth"
  >
    <v-card>
      <v-card-title>
        <v-layout column>
          <v-layout align-center>
            <span class="headline">
              {{ $t('deleteAccountDialogTitle') }}
            </span>
            <v-btn
              class="ml-auto mr-0 my-0"
              flat
              icon
              :title="$t('close')"
              :disabled="busy"
              @click="closeDialog()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <p class="error--text font-weight-bold subheading">
          {{ $t('deleteAccountDialogHint_1') }}
        </p>
        <p>{{ $t('deleteAccountDialogHint_2') }}:</p>
        <p class="text-xs-center">
          <span class="subheading grey--text text--darken-2 font-weight-bold">
            {{ $user.email }}
          </span>
        </p>
        <v-text-field
          :key="show"
          v-model="deleteAccountDialogConfirmationText"
          box
          clearable
          :rules="[
            (v) =>
              (!!v && !!$user && v === $user.email) ||
              $t('deleteAccountDialogInputInvalid'),
          ]"
          :title="$t('deleteAccountDialogHint_2')"
          :label="$t('deleteAccountDialogInputLabel')"
        />
        <div
          v-if="$userprofile && $userprofile.managed_workspace"
          class="pt-1 pb-3 warning--text"
        >
          <vue-markdown
            :source="
              $t('deleteAccountWorkspaceManagerWarning', {
                workspaceName: $userprofile.managed_workspace.name,
              })
            "
          />
        </div>
        <v-layout
          justify-center
          align-center
          wrap
        >
          <btn-abort
            round
            :label="$t('abort')"
            :disabled="busy"
            @click="closeDialog()"
          />
          <btn-ok
            :disabled="
              !$user ||
                !deleteAccountDialogConfirmationText ||
                deleteAccountDialogConfirmationText !== $user.email
            "
            round
            :loading="busy"
            :label="$t('deleteAccountButton')"
            @click="confirm()"
          />
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import VueMarkdown from 'vue-markdown';

import BtnAbort from '@/components/ButtonAbort';
import BtnOk from '@/components/ButtonOk';

export default {
  components: {
    BtnAbort,
    BtnOk,
    VueMarkdown,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      busy: false,

      deleteAccountDialogConfirmationText: null,
    };
  },
  computed: {},
  watch: {},
  methods: {
    reset() {
      this.deleteAccountDialogConfirmationText = null;
    },
    closeDialog() {
      this.reset();
      this.$emit('update:show', false);
    },
    confirm() {
      const email = this.deleteAccountDialogConfirmationText.trim();
      this.busy = true;
      this.$api
        .deleteUserAccount(email)
        .then(() => {
          this.$bus.$emit('alert-info', {
            translate: true,
            message: 'deleteAccountSuccess',
            timeout: 0,
          });
          this.$api.logout();
        })
        .finally(() => (this.busy = false));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/DeleteUserAccountDialog.vue